import React from 'react';
import { motion } from 'framer-motion';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const painPoints = [
  'Multiple logistics and customs partners',
  'Unpredictable delays and compliance risks',
  'Limited visibility once devices are in motion',
  'Firefighting that slows growth and strains teams',
];

const About: React.FC = () => {
  return (
    <section id="about" className="relative overflow-hidden bg-white py-14 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-10 h-72 w-72 rounded-full bg-[#385CF2]/6 blur-[120px]" />
        <div className="absolute right-0 bottom-10 h-80 w-80 rounded-full bg-[#0E9ED5]/6 blur-[140px]" />
      </div>

      <div className="container-custom relative">
        <motion.div {...reveal} transition={{ duration: 0.75 }} className="mx-auto max-w-3xl text-center">
          <h2 className="text-slate-950">Managing ICT Logistics is Increasingly Complex & Risky.</h2>
          <p className="mt-5 text-base leading-8 text-slate-600 sm:text-lg">
            As organisations expand globally, ICT hardware movement and management become increasingly fragmented
            and difficult to control.
          </p>
        </motion.div>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {painPoints.map((point, index) => (
            <motion.div
              key={point}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              className="flex items-start gap-4 rounded-[24px] border border-slate-200/70 bg-slate-50 p-6 shadow-[0_18px_40px_-34px_rgba(15,23,42,0.24)]"
            >
              <span className="mt-0.5 inline-flex flex-shrink-0 rounded-2xl bg-gradient-to-br from-[#385CF2] to-[#0E9ED5] p-2.5 text-white">
                <ExclamationCircleIcon className="h-5 w-5" />
              </span>
              <p className="text-base leading-7 text-slate-700">{point}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mx-auto mt-10 max-w-3xl text-center"
        >
          <p className="text-lg font-semibold leading-8 text-slate-950 sm:text-xl">
            We remove this complexity by acting as a single, accountable operational partner.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
